import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { observable, action, reaction } from 'mobx';
import { StoreExt } from '@utils/reactExt';
import { routerStore } from './../';
import { syncUserInfo } from './syncUserInfo';
import { SESSIONSTORAGE_KEYS } from '@constants/index';
import { updateAbility } from '@config/ability';
export var AuthStore = (_class = (_temp = class AuthStore extends StoreExt {
  /**
   * 用户信息
   *
   * @type {IAuthStore.UserInfo}
   * @memberof AuthStore
   */
  constructor() {
    super();

    _initializerDefineProperty(this, "userInfo", _descriptor, this);

    _initializerDefineProperty(this, "ability", _descriptor2, this);

    _initializerDefineProperty(this, "login", _descriptor3, this);

    this.logout = () => {
      this.setUserInfo(null);
      sessionStorage.removeItem(SESSIONSTORAGE_KEYS.USERINFO);
      location.replace(process.env.MANAGERURL);
    };

    _initializerDefineProperty(this, "setUserInfo", _descriptor4, this);

    reaction(() => this.userInfo, syncUserInfo);
  }

  get initialUserInfo() {
    var userInfo = sessionStorage.getItem(SESSIONSTORAGE_KEYS.USERINFO);
    return userInfo ? JSON.parse(userInfo) : null;
  }

  completeLogin(abilityContext) {
    updateAbility(abilityContext, this.userInfo.role);
    routerStore.replace(`/company-details/${this.userInfo.companyId}`);
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.initialUserInfo;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ability", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'admin';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "login", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;

    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token, abilityContext) {
        var user;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                sessionStorage.removeItem(SESSIONSTORAGE_KEYS.USERINFO);
                _context.next = 4;
                return _this.api.auth.login(token);

              case 4:
                user = _context.sent;

                if (user && user.token && Number(user.role) == 1) {
                  user.managerToken = token;
                  sessionStorage.setItem(SESSIONSTORAGE_KEYS.USERINFO, JSON.stringify(user));

                  _this.setUserInfo(user);

                  _this.completeLogin(abilityContext);
                } else {
                  _this.logout();
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "setUserInfo", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return userInfo => {
      this.userInfo = userInfo;
      return userInfo;
    };
  }
})), _class);
export default new AuthStore();